document.addEventListener("DOMContentLoaded", (event) => {
  const footerMenus = document.querySelectorAll(
    ".c-footer .footer__menu-wrapper .footer-block__menu",
  );

  footerMenus.forEach((item) => {
    const heading = item.querySelector(".footer-block__menu-heading");

    heading.addEventListener("click", () => {
      item.classList.toggle("collapsed");
    });
  });
});

// // country markets selector

//   class LocalizationForm extends HTMLElement {
//     constructor() {
//       super();
//       this.elements = {
//         input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
//         button: this.querySelector('button'),
//         panel: this.querySelector('.disclosure__list-wrapper'),
//       };
//       this.elements.button.addEventListener('click', this.openSelector.bind(this));
//       this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
//       this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

//       this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
//     }

//     hidePanel() {
//       this.elements.button.setAttribute('aria-expanded', 'false');
//       this.elements.panel.setAttribute('hidden', true);
//     }

//     onContainerKeyUp(event) {
//       if (event.code.toUpperCase() !== 'ESCAPE') return;

//       this.hidePanel();
//       this.elements.button.focus();
//     }

//     onItemClick(event) {
//       event.preventDefault();
//       const form = this.querySelector('form');
//       this.elements.input.value = event.currentTarget.dataset.value;
//       if (form) form.submit();
//     }

//     openSelector() {
//       this.elements.button.focus();
//       this.elements.panel.toggleAttribute('hidden');
//       this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
//     }

//     closeSelector(event) {
//       const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
//       if (event.relatedTarget === null || shouldClose) {
//         this.hidePanel();
//       }
//     }
//   }

//   customElements.define('localization-form', LocalizationForm);

// country markets selector adapted custom for UK/US

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]',
      ),
      button: this.querySelector("button"),
      panel: this.querySelector(".disclosure__list-wrapper"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this),
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this),
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this)),
    );
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const selectedLocale = event.currentTarget.dataset.value;

    let newUrl = "https://operabeds.com";
    if (selectedLocale.includes("US")) {
      newUrl += "/en-us";
    } else if (selectedLocale.includes("GB")) {
      // UK, no change needed, remains as operabeds.com
    } else {
      // Default behavior for other markets if added
      newUrl += `/${selectedLocale.toLowerCase()}`;
    }

    window.location.href = newUrl;
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString(),
    );
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define("localization-form", LocalizationForm);

class FooterButtons extends HTMLElement {
  constructor() {
    super();
    this.closeTimer = null;
    this.hoverCapable = window.matchMedia(
      "(hover: hover) and (pointer: fine)",
    );
  }

  connectedCallback() {
    this.footerButtons = this.querySelector(".footer-buttons--footer");
    this.stickyButtons = this.querySelector(".footer-buttons--sticky");
    this.toggle = this.stickyButtons.querySelector(".js-footer-buttons-toggle");
    this.links = this.stickyButtons.querySelector(".footer-buttons__links");
    this.links.inert = true;
    this.relocate();
    this.listeners();
    this.initScrollReveal();
  }

  // The section renders after <main>, which leaves the rail at the very end
  // of the tab order. Move it to just after the header so keyboard users
  // reach it early. Skipped in the theme editor so section re-renders work.
  relocate() {
    if (window.Shopify && window.Shopify.designMode) return;
    const main = document.getElementById("MainContent");
    if (main) main.before(this.stickyButtons);
  }

  get isOpen() {
    return this.stickyButtons.classList.contains("active");
  }

  open() {
    clearTimeout(this.closeTimer);
    this.stickyButtons.classList.add("active");
    this.toggle.setAttribute("aria-expanded", "true");
    this.links.inert = false;
  }

  close() {
    clearTimeout(this.closeTimer);
    // Focus would be lost to <body> once the links go inert, so hand it back
    // to the toggle.
    if (this.links.contains(document.activeElement)) this.toggle.focus();
    this.stickyButtons.classList.remove("active");
    this.toggle.setAttribute("aria-expanded", "false");
    this.links.inert = true;
  }

  // Small delay so briefly moving the cursor off the rail doesn't close it.
  // Never auto-closes while a keyboard user is inside the links.
  scheduleClose(delay = 400) {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      if (this.links.contains(document.activeElement)) return;
      this.close();
    }, delay);
  }

  listeners() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // The footer copy of the buttons is on screen, so slide the rail
          // fully away and take it out of the tab order / accessibility tree.
          this.classList.toggle(
            "footer-buttons--visible",
            entry.isIntersecting,
          );
          this.stickyButtons.classList.toggle(
            "footer-buttons--hidden",
            entry.isIntersecting,
          );
          if (entry.isIntersecting && this.isOpen) this.close();
          this.stickyButtons.inert = entry.isIntersecting;
        });
      },
      { threshold: 0.1 },
    );
    observer.observe(this.footerButtons);

    this.toggle.addEventListener("click", (event) => {
      // Stop the touch rail handler below from also acting on this click.
      event.stopPropagation();
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });

    this.stickyButtons.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() !== "ESCAPE" || !this.isOpen) return;
      this.close();
      this.toggle.focus();
    });

    this.stickyButtons.addEventListener("focusout", (event) => {
      if (this.stickyButtons.contains(event.relatedTarget)) return;
      if (this.isOpen) this.scheduleClose();
    });

    if (this.hoverCapable.matches) {
      this.stickyButtons.addEventListener("mouseenter", () => this.open());
      this.stickyButtons.addEventListener("mouseleave", () =>
        this.scheduleClose(),
      );
      return;
    }

    // Touch / no-hover devices (e.g. a touch laptop or iPad landscape at this
    // breakpoint): keep the original tap-to-open, tap-away-to-close behaviour.
    this.stickyButtons.addEventListener("click", (event) => {
      if (!this.isOpen) {
        event.preventDefault();
        this.open();
        return;
      }
      if (event.target.closest("a")) return;
      this.close();
    });

    document.body.addEventListener("click", (event) => {
      if (!this.isOpen) return;
      if (event.target.closest(".footer-buttons--sticky")) return;
      this.close();
    });
  }

  // One-off "teaser" reveal: the first time a visitor scrolls the homepage
  // this session, pop the rail open briefly, then let it dock again. After
  // that it behaves as a normal hover-dock for the rest of the session.
  initScrollReveal() {
    if (!this.hoverCapable.matches) return;
    if (this.dataset.homepage !== "true") return;
    if (sessionStorage.getItem("footerSidebarRevealed")) return;

    const onScroll = () => {
      if (window.scrollY < 40) return;
      window.removeEventListener("scroll", onScroll);
      sessionStorage.setItem("footerSidebarRevealed", "1");
      this.open();
      this.scheduleClose(2500);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
  }
}

customElements.define("footer-buttons", FooterButtons);
